// extracted by mini-css-extract-plugin
export default {"root":"FieldConfigPage_root__-eP2O","switchContainer":"FieldConfigPage_switchContainer__IMVLC","item":"FieldConfigPage_item__72KV3"};